<script setup lang="ts">
import { faOctagonXmark } from '@fortawesome/pro-solid-svg-icons'
import InputError from '~/components/form/InputError.vue'

withDefaults(defineProps<{
  label: string
  id: string
  rows?: string
  cols?: string
  errorMessage?: string
  hasErrors?: boolean
  autoResize?: boolean
  disabled?: boolean
  placeholder?: string
}>(), {
  autoResize: false,
  hasErrors: false,
  errorMessage: '',
  rows: '5',
  cols: '30',
  disabled: false,
  placeholder: '',
})

const emit = defineEmits<{
  (event: 'update:modelValue', value: any): void
}>()

const modelValue = defineModel<string | number>({ default: '' })

function clearInput() {
  emit('update:modelValue', '')
}
</script>

<template>
  <div class="relative flex flex-col flex-wrap gap-y-2xs justify-start">
    <label :for="id" class="text-caption flex flex-col gap-3xs text-black">
      <span v-text="label" />
      <textarea
        :id="id"
        v-model="modelValue"
        :rows="rows"
        :cols="cols"
        :autoResize="autoResize"
        :disabled="disabled"
        :aria-invalid="hasErrors"
        :placeholder="placeholder"
        class="min-h-[5.125rem] text-carbon-300 self-stretch p-2.5 bg-white rounded-lg border border-carbon-200"
        :class="{
          'rounded-lg border-2 border-red-500': hasErrors && !disabled,
          'enabled:hover:text-blurple-300 enabled:focus:text-blurple-300 hover:border-blurple-300 outline-none focus:outline-none focus:border-2 focus:border-blurple-300 focus:ring-0': !disabled,
        }"
      />
    </label>
    <Button v-if="!disabled && hasErrors" :icon="faOctagonXmark" class="!bg-transparent absolute top-6 right-2 !text-red-500" :disabled="disabled" @click="clearInput" />
    <InputError v-if="hasErrors && errorMessage">
      {{ errorMessage }}
    </InputError>
  </div>
</template>
